import React, {useState, useEffect} from 'react';
import {toJS} from 'mobx';
import {Table, Radio, Button, Popconfirm, Input, message} from 'antd';
import NumberInput from "../../../components/NumberInput";
import FormRow from "./FormRow";
import history from "../../../libs/history";
import styles from './layout.module.less'

import store from "../store";
import projectStore from "../../user/project/store";
import {observer} from 'mobx-react';

// import lodash from "lodash";
// import moment from "moment"


// the hook
import {useTranslation} from 'react-i18next';

import deletePng from './delete.png'

export default observer(function () {
  const {t, i18n} = useTranslation();
  const {records, selectedRowKeys, isFetching} = store
  const [loading, setLoading] = useState(false)

  const columns = [
    {
      title: t('类型'),
      dataIndex: 'catalog',
      className: 'pl0',
      width: 50,
      align:'center',
      fixed: true,
      render: (val,info) => <div
        className={[styles.badge, !info?.catalogName?.includes('销') ? styles.badgeGhost : '', i18n.language === 'en' ? styles.autoWidth : ''].join(' ')}>
         {t(info?.catalogName?.charAt(0)==='销'?'购':info?.catalogName?.charAt(0))}
      </div>,
    },
    {
      title: t('产品品名'),
      dataIndex: 'name',
      align: 'center',
      fixed: true,
      width: 160,
    },
    {
      title: t('品牌'),
      dataIndex: 'brand',
      align: 'center',
      fixed: true,
      width: 130,
    },
    {
      title: t('规格'),
      dataIndex: 'formats',
      align: 'center',
      fixed: true,
      width: 130,
    },
    {
      title: t('货号'),
      dataIndex: 'factoryCode',
      align: 'center',
      fixed: true,
      width: 150,
    },
    // {
    //   title: t('产品说明'),
    //   dataIndex: 'desc',
    //   align: 'center',
    //   fixed: true,
    //   width: 170,
    //   render: val => <div>{val ? val : '一'}</div>,
    // },
    {
      title: t('数量'),
      dataIndex: 'number',
      align: 'center',
      fixed: true,
      width: 90,
      render: (text, record, index) => <div style={{margin: '0 20px'}}>
        <NumberInput size='small' min={1}
                     defaultValue={text}
                     onChange={(val) => store.updateRecord(index, record, val,'number')}/></div>,
    },
    {
      title: t('需要计量'),
      dataIndex: 'isMeasure',
      align: 'center',
      fixed: true,
      width: 90,
      render: (val, record, index) =>
        <Radio checked={val} onClick={() => {
          onRadioClick(val, record, index)
        }}/>
    },
    {
      title: t('购物车备注'),
      dataIndex: 'cartRemarks',
      align: 'center',
      fixed: true,
      width: 150,
      render: (val, record, index) =>
        <Input autoComplete="off" 
          className='cart_input' 
          // size="large" 
          defaultValue={val}
          placeholder={t('最长50个字')}
          onBlur={e => store.updateRecord(index, record, e.target.value,'cartRemarks')}
        />
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'center',
      fixed: true,
      width: 100,
      render: (text, record, index) => <div className={styles.rowBtn}>
        <Popconfirm
          title={t("确定删除吗?")}
          onConfirm={() => {
            store.delRecord(text, index)
          }}
          okText={t("确定")}
          cancelText={t("取消")}>
            <img src={deletePng} alt="" style={{"cursor": "pointer",'width':'16px'}} />
          {/* <span className={['icon icon-del', styles.del].join(" ")}/> */}
        </Popconfirm>
      </div>,
    },
  ]

  useEffect(() => {
    store.userAddRecords = [];
    projectStore.records.length === 0 ?
      projectStore.fetchRecords().then(() => store.fetchRecords())
      : store.fetchRecords()
  }, [])

  // const disabledDate = (current) => {
  //   return current < moment().subtract(1, 'days')
  // }

  const onRadioClick = (val, record, index) => {
    let newVal = !record['isMeasure']
    store.updateRecord(index, record, newVal, 'isMeasure').then(() => {
      records[index]['isMeasure'] = newVal
    })
  }

  const onSelectChange = selectedRowKeys => {
    store.selectedRowKeys = selectedRowKeys
  }

  const clearCart = () => {
    // store.records = []
    // store.userAddRecords = []
    store.delRecordAll()
  }

  const postInquiry = () => {
    // const filteredUserAddRecords = store.userAddRecords.filter(v=>v.catalog);
    if (store.selectedRowKeys.length === 0 && store.userAddRecords.length === 0) {
      message.warn('请选择商品')
      return
    }
    if (store.userAddRecords.length) {
      if (!store.userAddRecords.every(v=>v.catalog)) {
        return message.error("类型不能为空！")
      }
      if (!store.userAddRecords.every(v=>v.name)) {
        return message.error("品名不能为空！")
      }
      if (!store.userAddRecords.every(v=>v.formats)) {
        return message.error("规格不能为空！")
      }
      if (store.userAddRecords.some(v=>v.name?.length>200)) {
        return message.error("品名不能超过200个字！")
      }
      if (store.userAddRecords.some(v=>v.brand?.length>50)) {
        return message.error("品牌不能超过50个字！")
      }
      if (store.userAddRecords.some(v=>v.formats?.length>50)) {
        return message.error("规格不能超过50个字！")
      }
      if (store.userAddRecords.some(v=>v.factoryCode?.length>100)) {
        return message.error("货号不能超过100个字！")
      }
    }

    setLoading(true)
    store.postInquiry().then(() => {
      store.file = {};
      history.push('/cart/submit?id=' + store.orderId)
    }).finally(() => setLoading(false))

  }


  return (
    <React.Fragment>
      <div className={styles.cart}>
        {/* <div className={['steps', styles.steps].join(" ")} data-class={'prev, cur'}>
          <div className="step cur" onClick={()=>history.push('/home')}>{'首页>'}</div>
          <div className="step">购物车</div>
        </div> */}

        <div className={styles.listTitle}>
          <span className={styles.title}>{t('求购清单')}</span>
          <span className={styles.des}>{t('订购后在货期内发货，若因特殊原因货期状态发生变化，客服人员会第一时间与您确认货期。')}</span>
        </div>

        <Table className={styles.table}
               pagination={false}
               bordered
               rowSelection={{
                 selectedRowKeys,
                 onChange: onSelectChange,
               }}
               dataSource={toJS(store.records)}
               rowKey={record => record.id}
               loading={isFetching}
               columns={columns}/>
        <FormRow/>

        <div className={styles.tableFooter}>
          <div className={styles.btns}>
            <Popconfirm
              title={t('确定清空购物车吗?')}
              onConfirm={clearCart}
              okText={t('确定')}
              cancelText={t('取消')}>
              <Button type='primary' ghost style={{marginRight: '20px'}}>{t('清空求购单')}</Button>
            </Popconfirm>
            <Button  type='primary' loading={loading} onClick={postInquiry}>{t('提交求购单')}</Button>
            <p className={styles.importTip}>{t('提交求购单后，我们会在2个小时内联系您')}</p>
          </div>
        </div>


      </div>

    </React.Fragment>
  )
})


